const accordions = {
	settings: {
		accordions: document.querySelectorAll('.js-accordion')
	},
	init() {
		this.setEvents();
	},
	setEvents() {
		if (!this.settings.accordions) return;

		this.settings.accordions.forEach((accordion, index) => {
			const trigger = accordion.querySelector('.js-accordion-trigger');
			const panel = accordion.querySelector('.js-accordion-panel');

			if (!trigger || !panel) return;

			trigger.addEventListener('click', () => this.toggle(trigger, panel));
			trigger.addEventListener('keydown', e => this.handleKey(e, trigger, panel));
			accordion.addEventListener('mouseenter', () => this.mouseEnter(accordion));
			accordion.addEventListener('mouseleave', () => this.mouseLeave());
			accordion.addEventListener('focus', () => this.mouseEnter(accordion));
		});
	},

	toggle(trigger, panel) {
		const expanded = trigger.getAttribute('aria-expanded') === 'true';
		trigger.setAttribute('aria-expanded', String(!expanded));
		panel.hidden = expanded;
	},

	handleKey(e, trigger, panel) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			this.toggle(trigger, panel);
		}
	},

	mouseEnter(active) {
		this.settings.accordions.forEach(accordion => {
			accordion.classList.toggle('accordions__item--active', accordion === active);
		});
	},

	mouseLeave() {
		this.settings.accordions.forEach(accordion => {
			accordion.classList.remove('accordions__item--active');
		});
	}
}

window.addEventListener('DOMContentLoaded', () => accordions.init());
